// Import gambar lokal
import ebook1 from '../../../assets/documents/jpg/ebooks/2025/menata-rumah-kecil/072425-REP_StudioNata-Ebook-MenataRumahKecil-1.jpg';
import ebook2 from '../../../assets/documents/jpg/ebooks/2025/membangun-rumah-4-kamar-di-lahan-6-meter-mungkinkah/072425-REP_StudioNata-Ebook-MembangunRumah4KamardiLahan6Meter-Mungkinkah_page-1.jpg';
import ebook3 from '../../../assets/documents/jpg/ebooks/2025/desain-rumah-anti-gagal/072425-REP_StudioNata-Ebook-DesainRumahAntigagal_page-0001.jpg';
import ebook4 from '../../../assets/documents/jpg/ebooks/2025/desain-rumah-islami/072425-REP_StudioNata-Ebook-Desain-Rumah-Islami_pages-to-jpg-0001.jpg';
import ebook5 from '../../../assets/documents/jpg/ebooks/2025/pintu-gerbang-kehormatan-rumah/130825-REP_StudioNata-Ebook-Pintu-Kehormatan-Rumah_page-0001.jpg';

const ProductsData = [
  {
    id: 1,
    name: "eBook Menata Rumah Kecil",
    price: "",
    image: ebook1,
    routePath: "/menata-rumah-kecil"
  },
  {
    id: 2,
    name: "eBook Membangun Rumah 4 Kamar di Lahan 6 Meter Mungkinkah",
    price: "",
    image: ebook2,
    routePath: "/ebooks-membangun-rumah-4-kamar-di-lahan-6-meter-mungkinkah"
  },
  {
    id: 3,
    name: "Desain Rumah Anti Gagal",
    price: "",
    image: ebook3,
    routePath: "/desain-rumah-anti-gagal"
  },
  {
    id: 4,
    name: "Desain Rumah Islami",
    price: "",
    image: ebook4,
    routePath: "/desain-rumah-islami"
  },
  {
    id: 5,
    name: "Pintu Gerbang Kehormatan Rumah",
    price: "",
    image: ebook5,
    routePath: "/pintu-gerbang-kehormatan-rumah"
  },
];

export default ProductsData;